import React, { type FunctionComponent, type ReactNode } from 'react'
import { DashFrame } from 'legacy/dash-blocks/dash-frame/DashFrame'
import { RouteSuspense } from 'legacy/dash-components/route-suspense/RouteSuspense'
import { OrdersListTabs } from 'legacy/sections/orders/components/list/components/tabs/OrdersListTabs'
import { OrdersListFilters } from 'legacy/sections/orders/components/list/components/filters/OrdersListFilters'
import { OrdersListTable } from 'legacy/sections/orders/components/list/components/table/OrdersListTable'
import { type OrdersListBehaviour } from 'legacy/sections/orders/components/list/utils/ordersList.hooks'

interface Props {
  header: ReactNode
  behaviour: OrdersListBehaviour
}

export const OrdersListContent: FunctionComponent<Props> = ({ header, behaviour }) => (
  <DashFrame
    fixedHeight
    header={header}
    sidebar={<OrdersListTabs {...behaviour} />}
    contentBar={<OrdersListFilters {...behaviour} />}
    contentBody={
      <RouteSuspense>
        <OrdersListTable {...behaviour} />
      </RouteSuspense>
    }
  />
)
